import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Short penis",
  "description": "",
  "published": "2008-02-05T00:00:00.000Z",
  "redirect_from": ["/blog/short-penis/swizec/130"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Lately I've been receiving a lot of emails about my penis being short and ways of fixing the problem. I always wonder just how the hell do they know that I have a small penis? It's remarkable! Do they make demographic research to find out who has a short weener? Or is there some kind of intricate heuristic algorithm at work?`}</p>
    <p>{`Well no, I probably just managed to post my email address somewhere a certain bot managed to read it, so now I've been tagged as a short weener guy (not saying it's not true). I used to receive a lot more of these a few years ago when my weener was even smaller and then for a few years where I was completely and totally secure about its size there were none. Now that I'm a tad less secure there's the emails again.`}</p>
    <p>{`Personally I find that interesting ... that there seems to be a correlation between the amount of spam messages for penis size increase and a person's security over the size of their member. How the hell!? Well I really canot be certain of how the hell that works, but it still feels as an interesting observation.`}</p>
    <p>{`Well anyhow, as long as I can pee with it ... you know ... fulfill its basic function and such ...`}</p>
    <p>{`While on the topic of spam. I keep getting an interesting emotion or whatever it is over seeing students my age, or even older ones, working in this office. The feeling doesn't stem quite from that, I'm a student working here after all. It comes from the difference in job descriptions. While they create spam envelopes for regular mail or answer the phones, I'm the semi-well paid programmer who gets to be creative and is listened to by the bosses as far as recommendations and such go.`}</p>
    <p>{`Life is good ... mostly.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      